var path = 'widget/lib/extensions-table-widget.tpl.html';
var html = " <md-tabs id=tabs md-border-bottom flex class=tb-absolute-fill ng-class=\"{'hide-tabs-menu': vm.datasources.length == 1 || vm.tabsHidden}\"> <md-tab ng-repeat=\"source in vm.datasources\" label=\"{{ source.name }}\" md-on-select=vm.changeSelectedSource(source)> <tb-extension-table flex entity-id=source.entityId entity-type={{source.entityType}} in-widget=true ctx=vm.ctx> </tb-extension-table> </md-tab> </md-tabs>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/lib/extensions-table-widget.tpl.html
// module id = 1476
// module chunks = 1